/**
 * Limpia texto pegado desde Word/PDF: colapsa espacios multiples y convierte
 * espacios duros (non-breaking space, U+00A0) que Word suele usar para
 * alinear texto manualmente. Devuelve `null` si el texto no necesita
 * cambios (para no interceptar el paste por defecto sin necesidad).
 */
export function normalizePastedText(
  text: string,
  options: { keepNewlines: boolean },
): string | null {
  if (!text) return null

  let normalized = text.replace(/\u00A0/g, " ")

  if (options.keepNewlines) {
    normalized = normalized
      .split(/\r\n|\r|\n/)
      .map((line) => line.replace(/[ \t]+/g, " ").trimEnd())
      .join("\n")
  } else {
    normalized = normalized.replace(/[ \t\r\n]+/g, " ").trim()
  }

  return normalized !== text ? normalized : null
}
